// extracted by mini-css-extract-plugin
module.exports = {"tab-list":"EditableProfile_tab-list__2b7kk","tab":"EditableProfile_tab__3mKNn","tab-active":"EditableProfile_tab-active__157mG"};